import React from 'react'

export default function Header() {
  return (
    <div className='p-2 mb-6'>
            <div className='mb-4'>
                <span className='text-5xl font-bold text-purple-300'>
                    HumaTube
                </span>
                <span className="text-white ml-2">(Demo website)</span>
            </div>
        <hr />
    </div>
  )
}
